import { useFormContext, type FieldValues } from 'react-hook-form';

import { Input as PayflowUIInput, Skeleton } from '@ctct/payflow-ui';

import { Field } from './Field';
import { useFormLoadingContext } from './FormLoadingContext';
import { errorAdapter } from './helpers';
import type { PropsBase } from './types';

export function FormFieldNonFekit<T extends FieldValues>({
  label = '',
  name,
  qeId,
  optional,
  placeholder,
  disableMarginBottom,
  type,
  disabled,
}: PropsBase<T> & { disabled?: boolean }) {
  const id = `form-field-${name}`;
  const isLoading = useFormLoadingContext();

  const {
    register,
    formState: { errors },
  } = useFormContext<T>();

  const error = errors[name];
  const { ref, ...registered } = register(name);

  return (
    <Field
      data-qe-id={qeId}
      label={label}
      labelFor={id}
      error={errorAdapter(error)}
      category={optional ? 'optional' : undefined}
      style={{ marginBottom: disableMarginBottom ? 0 : undefined }}
    >
      {isLoading ? (
        <Skeleton height={35} />
      ) : (
        <PayflowUIInput
          id={id}
          ref={ref}
          data-qe-id={qeId.concat('-input')}
          invalid={!!error}
          placeholder={placeholder}
          type={type}
          disabled={disabled}
          {...registered}
        />
      )}
    </Field>
  );
}
